import * as yup from 'yup';

const createRequiredFieldTest = (
  fieldName: string,
  dependentFields: string[],
) => {
  return yup
    .string()
    .nullable()
    .test({
      name: fieldName,
      test: (value, context) => {
        const parent: Record<string, unknown> = context.parent;
        const isFieldEmpty = !Boolean(parent[fieldName]);
        const isAnyDependentFieldFilled = dependentFields.some((depField) =>
          Boolean(parent[depField]),
        );

        if (isFieldEmpty && isAnyDependentFieldFilled) {
          return context.createError({
            message: `${
              fieldName.charAt(0).toUpperCase() + fieldName.slice(1)
            } is required`,
          });
        }
        return true;
      },
    });
};

export const prospectDetailsSchema = yup.object().shape({
  name: yup
    .string()
    .matches(/[a-zA-Z].*[a-zA-Z]/, 'Name must contain at least two letters')
    .required('Name is required'),
  address1: createRequiredFieldTest('address1', ['city', 'state', 'zip']),
  city: createRequiredFieldTest('city', ['address1', 'state', 'zip']),
  zip: createRequiredFieldTest('zip', ['address1', 'city', 'state']),
  state: createRequiredFieldTest('state', ['address1', 'city', 'zip']),
});
